export const INSTRUCTION_MODAL_SHOWED_TIMES = "instruction-modal-showed-times";
